import React from "react"

import styles from "../styles/UnderMaintenance.module.scss"

export function UnderMaintenance(props) {
  return (
    <div className={styles.UnderMaintenanceComponent}>
      <h1>This Page is Down for Maintenance</h1>
      <p>
        Please check our twitter account for updates.
        <br/>
        <a href="https://twitter.com/buildbox" target="blank">@buildbox</a>
      </p>
    </div>
  )
}
